/**
 * Flint Collection Grid - Sort and Filter Handling
 * - Category pill filter buttons (dynamic based on tags)
 * - Sort by dropdown
 * - Product filtering by tags
 */

(function() {
  'use strict';

  function initCollectionGrid() {
    // Handle Category Filter Pills
    const filterPills = document.querySelectorAll('.flint-grid__filter-pill');
    const productCards = document.querySelectorAll('.flint-grid__product-card');
    
    if (filterPills.length === 0) return;

    filterPills.forEach(pill => {
      pill.addEventListener('click', function() {
        const filter = this.getAttribute('data-filter');
        
        // Update active state
        filterPills.forEach(p => p.classList.remove('flint-grid__filter-pill--active'));
        this.classList.add('flint-grid__filter-pill--active');
        
        // Filter products by tags
        productCards.forEach(card => {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            const productTags = card.getAttribute('data-tags') || '';
            if (productTags.includes(filter)) {
              card.style.display = '';
            } else {
              card.style.display = 'none';
            }
          }
        });
      });
    });

    // Handle Sort By dropdown - support multiple instances
    const sortSelects = document.querySelectorAll('.flint-grid__sort-select');
    
    sortSelects.forEach(select => {
      select.addEventListener('change', function() {
        const sortBy = this.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy);
        window.location.href = url.toString();
      });
    });

    // Video Performance Optimization - Pause when out of view
    const videos = document.querySelectorAll('.flint-grid__product-video');
    
    if (videos.length > 0 && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {
              // Auto-play was prevented, that's okay
            });
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5,
        rootMargin: '50px'
      });
      
      videos.forEach(video => videoObserver.observe(video));
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionGrid);
  } else {
    initCollectionGrid();
  }
})();
